import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StatItem {
  id: number;
  value: string;
  label: string;
  icon: string;
  description: string;
}

const ImpactStatsSection = () => {
  const stats: StatItem[] = [
    {
      id: 1,
      value: '18.4K+',
      label: 'Lives Impacted',
      icon: 'UserGroupIcon',
      description: 'Individuals reached through humanitarian programs'
    },
    {
      id: 2,
      value: '23',
      label: 'Active Projects',
      icon: 'MapPinIcon',
      description: 'Ongoing initiatives across 12 countries'
    },
    {
      id: 3,
      value: '$780K',
      label: 'Funds Deployed',
      icon: 'CurrencyDollarIcon',
      description: 'Direct support to vulnerable communities'
    },
    {
      id: 4,
      value: '98.2%',
      label: 'Transparency Score',
      icon: 'ShieldCheckIcon',
      description: 'Independently verified fund allocation'
    }
  ];

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-headline font-bold text-foreground mb-4">
            Real-Time Impact Dashboard
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Every number represents a life changed, a community healed, and hope restored through collective compassion.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="bg-card rounded-xl p-8 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 border border-border"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={stat.icon as any} size={28} className="text-primary" variant="solid" />
                </div>
              </div>
              
              <div className="text-4xl font-headline font-bold text-primary mb-2">
                {stat.value}
              </div>
              
              <div className="text-lg font-cta font-bold text-foreground mb-2">
                {stat.label}
              </div>
              
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactStatsSection;